import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const rateTypes = {
    shippingRate: "shipping_rate",
    shippingRule: "shipping_rule",
    taxRate: "tax_rate"
}

export const targetTypes = {
    shippingRate: "shipping_rate",
    shippingRule: "shipping_rule",
    taxRate: "tax_rate"
}

const calculationTypes = [
    {
        id: "fixed",
        display: "Fixed"
    },
    {
        id: "tier",
        display: "Tier"
    }
]

export function useRates({
    rateType: _rateType,
    targetType: _targetType
}) {

    const [rateType, setRateType] = useState(_rateType);
    const [targetType, setTargetType] = useState(_targetType)

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "rates";
    const endpoint2 = "rate";

    const list = async (props) => {

        setIsLoading(true);

        try {

            let { rateType: overrideRateType } = props

            let url = getListsUrl(`${endpoint}/${rateType}`, props)

            if (overrideRateType) {
                url = getListsUrl(`${endpoint}/${overrideRateType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const create = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/${id}`

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            // let url = `${endpoint}/${repositoryType}/delete`
            let url = `${endpoint}/delete`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const removeItem = async ({ ids, targetType: overrideTargetType }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            // let url = `${endpoint}/${repositoryType}/delete`
            let url = `${endpoint}/delete_item`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, rateType: overrideRateType = '', dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint2}/${rateType}/${id}`, dataTypesArray);

            if (overrideRateType) {
                url = getUrlWithDataTypes(`${endpoint2}/${overrideRateType}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const calculate = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/calculate_rate`;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        calculationTypes,
        list,
        get,
        create,
        update,
        remove,
        removeItem,
        calculate
    }
}